import { gql } from 'graphql.macro';

export const GetOpportunityById = gql`
    query GetOpportunity($id: Int!) {
        opportunity: opportunityById(id: $id) {
            observationId
            uniqueRecordId
            companyId
            locationType
            offSiteLocation {
                customerSiteName
                locationDescription
                locationLatitude
                locationLongitude
            }
            depotPcId
            observationCategoryName
            whatHappened
            anonymousEntry
            reporterType
            reportedBy {
                reporterContactName
                reporterPhoneNumber
                reporterEmail
            }
            observationStatus
            lastModified
            incidentDate
            completion {
                closureReason
                closeDate
                employeeId
                hasAttachments
            }
            reachId
            processId
        }
    }
`;
